import type { Modal } from 'types'
import store from './store'

export const showActiveModal = store<boolean>(false)

export const activeModal = store<Modal | undefined>()
